import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {
  REPO_ISSUES_TAB_CONTENT_STYLE,
  RepoIssuesPageLayout,
} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {RepositoryLabelsInternal} from '@github-ui/repository-label/RepositoryLabels'
import {Button} from '@primer/react'
import {useState} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'
import {labelsRoute} from './labels-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function Labels() {
  const {owner, repo} = useRouteParams(labelsRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const payload = useRouteQuery(labelsRoute, 'mainQuery')

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  // on FORBIDDEN/SAML this reloads the page; otherwise it throws to the error boundary
  const data = handleRepositoryDataError(payload.data)
  const repository = data?.repository
  const isArchivingEnabled = layoutPayload?.hasLabelsArchivingEnabled

  // Header action only in the sidebar layout; the legacy layout uses RepositoryLabelsInternal's
  // own inline button (uncontrolled dialog).
  const headerActions =
    sidebarLayoutEnabled && repository?.viewerCanCreateLabels ? (
      <Button variant="primary" onClick={() => setIsCreateDialogOpen(true)}>
        New label
      </Button>
    ) : undefined

  // This leaf owns its layout in both flag states (the parent is a passthrough). RepoIssuesPageLayout
  // ignores title/actions when the sidebar layout is off, where RepositoryLabelsInternal renders the
  // inline title + New label button.
  return (
    <BaseAnalyticsWrapper category="Repository Label Index" appName="issues">
      <RepoIssuesPageLayout
        dialogTitle="Labels"
        title="Labels"
        actions={headerActions}
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebarExpanded}
        contentStyle={REPO_ISSUES_TAB_CONTENT_STYLE}
      >
        {/* repository is undefined only during a FORBIDDEN/SAML reload; keep the chrome, drop the list */}
        {repository ? (
          sidebarLayoutEnabled ? (
            <RepositoryLabelsInternal
              repository={repository}
              queryKey={payload.queryKey}
              isCreateDialogOpen={isCreateDialogOpen}
              isArchivingEnabled={isArchivingEnabled}
              onCreateDialogOpenChange={setIsCreateDialogOpen}
            />
          ) : (
            <RepositoryLabelsInternal
              repository={repository}
              queryKey={payload.queryKey}
              isArchivingEnabled={isArchivingEnabled}
            />
          )
        ) : null}
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
